import { Box, Flex, Text } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/react'
import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { useTranslation } from 'react-i18next'
import type { DateGetterSetterProps } from '../../interfaces'
import DatePickerWrapperComponent from './DatePickerWrapperComponent'
import moment from 'moment'

const DateSelector = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  handleDateSubmit,
  disabled,
  isRefreshing,
  dateError,
  width,
  minStartDate,
}: DateGetterSetterProps): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex direction="row" align="center">
      <Box marginRight="15px" w={width ? width : 'auto'}>
        <DatePickerWrapperComponent
          selected={startDate}
          onChange={(date: Date) => {
            setStartDate(date)
            if (moment(date).isAfter(endDate)) {
              setEndDate(moment(date).endOf('day').toDate())
            }
          }}
          maxDate={new Date()}
          minDate={minStartDate}
        />
      </Box>
      <Box marginRight="15px" w={width ? width : 'auto'}>
        <DatePickerWrapperComponent
          selected={endDate}
          onChange={(date: Date) => {
            const dateToSet = moment(date)
            if (dateToSet.isValid()) {
              setEndDate(dateToSet.endOf('day').toDate())
            } else {
              // TODO(kunal): This has been done to avoid changing the common interface in DateGetterSetterProps
              // which would spill over changes in multiple components unrelated to this feature's MR.
              // This'll be removed when the type is updated for other components too.
              setEndDate(null as unknown as Date)
            }
          }}
          minDate={startDate}
          maxDate={new Date()}
        />
      </Box>
      <Box mr="15px">
        <Button
          onClick={() => {
            handleDateSubmit()
          }}
          isDisabled={disabled}
        >
          {isRefreshing && t('please_wait', 'Please wait...')}
          {!isRefreshing && t('submit', 'Submit')}
        </Button>
      </Box>
      {disabled && !isRefreshing ? (
        <Text color="#e53e3e">
          {dateError
            ? dateError
            : t(
                'max_range_90_days',
                'You can select a maximum range of 90 days!',
              )}
        </Text>
      ) : null}
    </Flex>
  )
}

export default DateSelector
